<template>
  <v-modal
    v-if="true"
    size="md"
    @hide-modal="$emit('hide-modal')"
    :closable="closable"
  >
    <template v-slot:title>
      <h3>
        {{ $t(title) }}
      </h3>
      <div class="text-muted">
        {{ $t(subTitle) }}
      </div>
    </template>
    <template v-slot:body>
      <v-auth-form
        @authenticated="(payload) => {$emit('authenticated', payload)}"
        :as-organisation="asOrganisation"
        :login-only="loginOnly"
      />
    </template>
  </v-modal>
</template>

<script>
import Modal from '@/common/components/Modal.vue';
import AuthForm from '@/common/components/auth/AuthForm.vue';

export default {
  name: 'AuthModal',
  components: {
    'v-modal': Modal,
    'v-auth-form': AuthForm,
  },
  props: {
    loginOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    subTitle: {
      default() {
        return 'sentence.create_account_or_login';
      },
    },
    title: {
      default() {
        return 'sentence.not_logged_in';
      },
    },
    asOrganisation: {
      type: Boolean,
      default() {
        return false;
      },
    },
    closable: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      mode: 'register',
    };
  },
};
</script>
